// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uvHt","name":"Header_name__3dkV8","birthday":"Header_birthday__Exk2F","skeleton":"Header_skeleton__KrPly"};